module.exports = __webpack_public_path__ + "static/media/dr-tharuka2-news.89a5f754.jpg";